import { connect } from 'react-redux';
import ResultCounter from '../resultCounter';

const mapStateToProps = state => ({
  current: state.find.currentMatch,
  total: state.find.matchCount || 0,
  searchInProgress: state.find.searchInProgress || false,
});

export const ResultCounterContainer = connect(mapStateToProps)(ResultCounter);
